<div class="vstack gap-2 mb-3" *ngIf="clientPolicySelection.selected.length">
  <div
    class="selection-group"
    *ngFor="let clientPolicy of clientPolicySelection.selected"
  >
    <div class="d-flex justify-content-between">
      <span class="mat-h5">
        {{ clientPolicy.client.insuredName }}
      </span>
      <button
        type="button"
        luiCab
        size="sm"
        (click)="editSelection(clientPolicy)"
        iconPosition="end"
      >
        <ng-container i18n>Edit</ng-container>
        <mat-icon svgIcon="edit"></mat-icon>
      </button>
    </div>
    <div class="vstack gap-1 mt-1">
      <div class="selection" *ngFor="let policy of clientPolicy.policies">
        <div
          class="hstack gap-1"
          *ngrxLet="policy.classOfBusinessId | cobMeta as cobMeta"
        >
          <lui-avatar [color]="cobMeta.color" [size]="48">
            <mat-icon [svgIcon]="cobMeta.icon"></mat-icon>
          </lui-avatar>
          <span>{{ cobMeta.title }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="vstack gap-1">
  <ng-container *ngIf="clients.length <= selectBoxLimit; else selectBlock">
    <lui-form-field>
      <lui-label i18n>Choose company</lui-label>
      <lui-select-box-group
        [formControl]="clientControl"
        [compareWith]="clientCompareWith"
      >
        <div class="row g-1">
          <div class="col-6" *ngFor="let option of clients">
            <lui-select-box
              [value]="option"
              [disabled]="selectedClientIds | includes : option.id"
            >
              {{ option.insuredName }}
            </lui-select-box>
          </div>
        </div>
      </lui-select-box-group>
    </lui-form-field>
  </ng-container>

  <ng-template #selectBlock>
    <mat-form-field>
      <mat-label i18n>Choose company</mat-label>
      <mat-select [formControl]="clientControl">
        <mat-option disabled *ngIf="!clients.length" i18n
          >No clients available</mat-option
        >
        <mat-option *ngFor="let option of clients" [value]="option">
          {{ option.insuredName }}
        </mat-option>
      </mat-select>
      <mat-error i18n>Please select a company</mat-error>
    </mat-form-field>
  </ng-template>

  <div
    matTooltip="Please choose a company first"
    matTooltipPosition="before"
    [matTooltipDisabled]="clientControl.value !== null"
    i18n-matTooltip
  >
    <mat-form-field>
      <mat-label i18n>Choose policies</mat-label>
      <mat-chip-grid
        #chipGrid
        aria-label="Choose policies"
        i18n-aria-label
        [formControl]="productControl"
      >
        <mat-chip-row
          *ngFor="let policy of policySelection.selected"
          [editable]="true"
          [value]="policy"
          (removed)="onPolicyChipRemove(policy)"
        >
          {{ (policy.classOfBusinessId | cobMeta).title }}
          <button matChipRemove aria-label="Deselect" i18n-aria-label>
            <mat-icon svgIcon="close"></mat-icon>
          </button>
        </mat-chip-row>
        <input
          placeholder="Choose a policy"
          [matChipInputFor]="chipGrid"
          [matAutocomplete]="auto"
          #policiesInput
          [formControl]="productInputControl"
          i18n-placeholder
        />
      </mat-chip-grid>

      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="onSelectPolicy($event)"
      >
        <ng-container *ngIf="filteredPolicyOptions$ | async as policyOptions">
          <mat-option disabled *ngIf="!policyOptions.length" i18n
            >No policies match selection</mat-option
          >
          <ng-container *ngFor="let option of policyOptions">
            <mat-option
              *ngrxLet="option.value.classOfBusinessId | cobMeta as cobMeta"
              [value]="option.value"
              [disabled]="option.disabled"
            >
              <div class="hstack gap-1 py-_5">
                <lui-avatar [color]="cobMeta.color" [size]="48">
                  <mat-icon [svgIcon]="cobMeta.icon"></mat-icon>
                </lui-avatar>
                <span>
                  {{ cobMeta.title }}
                </span>
              </div>
            </mat-option>
          </ng-container>
        </ng-container>
      </mat-autocomplete>
      <mat-error i18n>Please select a policy</mat-error>
    </mat-form-field>
  </div>
</div>

<mat-error *ngIf="control.touched && control.invalid" i18n
  >Please select a policy</mat-error
>

<button
  type="button"
  luiCab
  size="lg"
  (click)="assignSelectedPolicies()"
  iconPosition="start"
>
  <mat-icon svgIcon="add"></mat-icon>
  <ng-container i18n>Assign another</ng-container>
</button>
